<template>
  <div  v-on="slideListeners" class="lee-slide" ref="lee-slide" @mouseup="huadao" @touchstart="mhuadao" :inert="value===0">
    <div class="lee-slide-runway" :class="classObject">
      <template v-if="showStop">
        <div class="lee-slide-stop" v-for="(item,xh) in stops" :key="xh" :style="{left:(item)+'%'}"></div>
      </template>
      <template v-if="!range">
        <div class="lee-slide-bar" :style="{width:(posx)+'%'}"></div>
        <div v-if="!noDrag" class="lee-slide-wrap" @mouseenter="mouseenter" @mouseleave="mouseleave"
             @mousedown.prevent="mousedown"
             @mouseup="mouseup" @touchstart.prevent="touchstart" v-on="slideListeners"
             :style="{left:(posx)+'%'}">
          <div class="lee-slide-button"></div>
          <transition name="fade">
            <div class="lee-slide-tooltip" v-if="showTip&&(down||over)">{{toFix(posx)}}</div>
          </transition>
        </div>
      </template>
      <template v-if="range">
        <div class="lee-slide-bar"
             :style="{width:(Math.abs(posxs[1]-posxs[0]))+'%',left:(Math.min(...posxs))+'%'}"></div>
        <div v-for="(item,xh) in posxs" class="lee-slide-wrap" @mouseenter="mouseenter(xh)" @mouseleave="mouseleave(xh)"
             @mousedown.prevent="mousedown(xh)"
             @touchstart.prevent="touchstart(xh)"
             :style="{left:(item)+'%'}">
          <div class="lee-slide-button"></div>
          <transition name="fade">
            <div class="lee-slide-tooltip" v-if="showTip&&(downs[xh]||overs[xh])">{{toFix(item)}}</div>
          </transition>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
    name: 'LeeSlide',
    inheritAttrs: false,
    data() {
        return {
            newSize: '',
            newTheme: '',
            down: false,//是否按下
            downs: [false, false],//是否按下
            over: false,//
            overs: [false, false],//
            oldx: 0,
            posx: 0,//滑块的位置
            posxs: [0, 0],//滑块的位置
            fullw: 0,
            savex: 0,//拖动后保存位置
            savexs: [0, 0],//拖动后保存位置
            stops: [],
            xh: 0
        }
    },
    methods: {
        toFix(num) {
            return num.toFixed(0)
        },
        chuli() {
            for (let i = 1; i < (this.max - this.min) / this.step; i++) {
                this.stops.push(i * (this.step))
            }
            if (this.oldx === 0) {//并且没有滑动过
                if (!this.range) {
                    this.posx = this.value
                    this.savex = this.posx
                } else {
                    for (let i = 0; i < this.value.length; i++) {
                        this.$set(this.posxs, i, this.value[i])
                        this.$set(this.savexs, i, this.value[i])
                    }
                }
            }
            document.addEventListener('mousemove', (e) => {
                let mm = Math.round((e.pageX - this.oldx) / this.fullw * 100)
                if (!this.range) {
                    if (this.down && mm % this.step === 0) {
                        this.posx = this.savex + mm
                        if (this.posx >= 100) {
                            this.posx = 100
                        }
                        if (this.posx <= 0) {
                            this.posx = 0
                        }
                        this.$emit('input', this.posx)
                    }
                } else {
                    if (this.downs[this.xh] && mm % this.step === 0) {
                        this.$set(this.posxs, this.xh, this.savexs[this.xh] + mm)
                        for (let i = 0; i < this.posxs.length; i++) {
                            if (this.posxs[i] >= 100) {
                                this.posxs[i] = 100
                            }
                            if (this.posxs[i] <= 0) {
                                this.posxs[i] = 0
                            }
                        }
                        this.$emit('input', this.posxs)
                    }
                }

            })
            document.addEventListener('mouseup', (e) => {
                if (!this.range) {
                    this.down = false
                    this.savex = this.posx
                } else {
                    this.$set(this.downs, this.xh, false)
                    this.$set(this.savexs, this.xh, this.posxs[this.xh])
                }
            })
            document.addEventListener('touchmove', (e) => {
                let mm = Math.round((e.targetTouches[0].pageX - this.oldx) / this.fullw * 100)
                if (!this.range) {
                    if (this.down && mm % this.step === 0) {
                        this.posx = this.savex + mm
                        if (this.posx >= 100) {
                            this.posx = 100
                        }
                        if (this.posx <= 0) {
                            this.posx = 0
                        }
                        this.$emit('input', this.posx)
                    }
                } else {
                    if (this.downs[this.xh] && mm % this.step === 0) {
                        this.$set(this.posxs, this.xh, this.savexs[this.xh] + mm)
                        for (let i = 0; i < this.posxs.length; i++) {
                            if (this.posxs[i] >= 100) {
                                this.posxs[i] = 100
                            }
                            if (this.posxs[i] <= 0) {
                                this.posxs[i] = 0
                            }
                        }
                        this.$emit('input', this.posxs)
                    }
                }
            })
            document.addEventListener('touchend', (e) => {
                if (!this.range) {
                    this.down = false
                    this.savex = this.posx
                } else {
                    this.$set(this.downs, this.xh, false)
                    this.$set(this.savexs, this.xh, this.posxs[this.xh])
                }
            })
        },
        huadao() {
            if (!this.range) {
                let offsetLeft = event.currentTarget.getBoundingClientRect().x
                this.posx = this.savex = Math.round((event.pageX - offsetLeft) / this.fullw * 100)
                this.$emit('input', this.posx)

            }
        },
        mhuadao() {
            if (!this.range) {
                let offsetLeft = event.currentTarget.getBoundingClientRect().x
                this.posx = this.savex = Math.round((event.targetTouches[0].pageX - offsetLeft) / this.fullw * 100)
                this.$emit('input', this.posx)
            }
        },
        mouseenter(xh) {
            if (typeof (xh) === 'object') {
                this.over = true
            } else {
                this.$set(this.overs, xh, true)
            }

        },
        mouseleave(xh) {
            if (typeof (xh) === 'object') {
                this.over = false
            } else {
                this.$set(this.overs, xh, false)
            }
        },
        mousedown(xh) {
            this.xh = xh
            if (typeof (xh) === 'object') {
                this.down = true
            } else {
                this.$set(this.downs, xh, true)
            }
            this.oldx = event.pageX
        },
        mouseup() {
            if (!this.range) {
                this.down = false
                this.savex = this.posx
            } else {
                //this.$set(this.downs, this.xh, false)
                //this.$set(this.savexs, this.xh, this.posxs[this.xh])
            }
        },
        touchstart(xh) {
            this.xh = xh
            if (typeof (xh) === 'object') {
                this.down = true
            } else {
                this.$set(this.downs, xh, true)
            }
            this.oldx = event.targetTouches[0].pageX
        },
    },
    mounted() {
        //
        this.fullw = this.$refs['lee-slide'].offsetWidth

        this.chuli()
        window.addEventListener('resize', (e) => {
            if (this.$refs['lee-slide']) {
                this.fullw = this.$refs['lee-slide'].offsetWidth
                this.chuli()
            }
        })
        //如果参数乱写
        let AllTheme = 'red,yellow,black,green,blue';
        let AllSize = 's,m,l';
        if (AllTheme.indexOf(this.theme) == -1) {
            this.newTheme = 'blue'
        } else {
            this.newTheme = this.theme
        }
        if (AllSize.indexOf(this.size) == -1) {
            this.newSize = 'm'
        } else {
            this.newSize = this.size
        }

    },
    computed: {
        slideListeners() {
            return Object.assign({}, this.$listeners, {
                mousedown: (event) => {
                    this.$emit('mousedown', event);
                },
                mouseup: (event) => {
                    this.$emit('mouseup', event);
                },
            })
        },
        classObject() {
            return this.newSize + ' ' + this.newTheme
        }
    },
    props: {
        theme: {
            type: String,
            default: 'blue' //默认default
        },
        size: {
            type: String,
            default: 'm' //默认default
        },
        value: [Number, Array],
        // initValue: {
        //     type: Number,
        //     default: 0//默认default
        // },
        showTip: {
            type: Boolean,
            default: true//默认default
        },
        min: {
            type: Number,
            default: 0//默认default
        },
        max: {
            type: Number,
            default: 100//默认default
        },
        step: {
            type: Number,
            default: 1//默认default
        },
        showStop: {
            type: Boolean,
            default: false//默认default
        },
        noDrag: {
            type: Boolean,
            default: false//默认default
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (typeof (value) === 'number') {
                    this.range = false
                    this.posx = this.value//很关键
                    if (!this.down) {
                        this.savex = this.posx//很关键
                    }
                } else {
                    this.range = true
                }
            }
        }
    },
};
</script>
<style>
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-enter-to, .fade-leave {
  opacity: 1;
}

.lee-slide {
  width: 100%;
}
.lee-slide[inert]{
  filter: grayscale(1);
}

.lee-slide-runway {
  width: 100%;
  height: 6px;
  background-color: #e4e7ed;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
}

.lee-slide-runway .lee-slide-bar {
  height: 6px;
  /*border-radius: 3px 0 0 3px;*/
  position: absolute;
  left: 0;
}

.lee-slide-runway .lee-slide-stop {
  background-color: #fff;
  border-radius: 100%;
  position: absolute;
}

.lee-slide-runway .lee-slide-wrap {
  width: 20px;
  height: 20px;
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
}

.lee-slide-runway .lee-slide-wrap .lee-slide-tooltip {
  position: absolute;
  color: #fff;
  border-radius: 3px;
  padding: 4px 8px;
  font-size: 12px;
  left: 50%;
  transform: translateY(-140%) translateX(-50%);
  transition: all .6s;
}

.lee-slide-runway .lee-slide-wrap .lee-slide-tooltip:after {
  content: '';
  border-style: solid;
  border-width: 6px;
  border-color: transparent transparent transparent transparent;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(90%);
}

.lee-slide-runway .lee-slide-wrap .lee-slide-button {
  width: 20px;
  height: 20px;
  border-style: solid;
  border-width: 2px;
  background-color: #fff;
  border-radius: 50%;
  transition: all .5s;
  position: absolute;
}

.lee-slide-runway .lee-slide-wrap .lee-slide-button:hover {
  transform: scale(1.2);
}

/*主題顏色*/
.lee-slide-runway.blue .lee-slide-bar {
  background-color: #409eff;
}

.lee-slide-runway.blue .lee-slide-wrap .lee-slide-button {
  border-color: #409eff
}

.lee-slide-runway.blue .lee-slide-wrap .lee-slide-tooltip {
  background-color: #409eff
}

.lee-slide-runway.blue .lee-slide-wrap .lee-slide-tooltip:after {
  border-top-color: #409eff
}

.lee-slide-runway.red .lee-slide-bar {
  background-color: #f00;
}

.lee-slide-runway.red .lee-slide-wrap .lee-slide-button {
  border-color: #f00
}

.lee-slide-runway.red .lee-slide-wrap .lee-slide-tooltip {
  background-color: #f00
}

.lee-slide-runway.red .lee-slide-wrap .lee-slide-tooltip:after {
  border-top-color: #f00
}

.lee-slide-runway.yellow .lee-slide-bar {
  background-color: #fa0;
}

.lee-slide-runway.yellow .lee-slide-wrap .lee-slide-button {
  border-color: #fa0
}

.lee-slide-runway.yellow .lee-slide-wrap .lee-slide-tooltip {
  background-color: #fa0
}

.lee-slide-runway.yellow .lee-slide-wrap .lee-slide-tooltip:after {
  border-top-color: #fa0
}

.lee-slide-runway.black .lee-slide-bar {
  background-color: #000;
}

.lee-slide-runway.black .lee-slide-wrap .lee-slide-button {
  border-color: #000
}

.lee-slide-runway.black .lee-slide-wrap .lee-slide-tooltip {
  background-color: #000
}

.lee-slide-runway.black .lee-slide-wrap .lee-slide-tooltip:after {
  border-top-color: #000
}

.lee-slide-runway.green .lee-slide-bar {
  background-color: #67c23a;
}

.lee-slide-runway.green .lee-slide-wrap .lee-slide-button {
  border-color: #67c23a
}

.lee-slide-runway.green .lee-slide-wrap .lee-slide-tooltip {
  background-color: #67c23a
}

.lee-slide-runway.green .lee-slide-wrap .lee-slide-tooltip:after {
  border-top-color: #67c23a
}

/*尺寸*/
.lee-slide-runway.s {
  height: 2px;
  border-radius: 1px;
}

.lee-slide-runway.s .lee-slide-stop {
  width: 2px;
  height: 2px;
}

.lee-slide-runway.s .lee-slide-bar {
  height: 2px;
  border-radius: 1px;
}

.lee-slide-runway.s .lee-slide-wrap {
  width: 12px;
  height: 12px;
}

.lee-slide-runway.s .lee-slide-wrap .lee-slide-tooltip {
  padding: 2px 4px;
}

.lee-slide-runway.s .lee-slide-wrap .lee-slide-button {
  width: 12px;
  height: 12px;
}

.lee-slide-runway.m {
  height: 6px;
  border-radius: 3px;
}

.lee-slide-runway.m .lee-slide-stop {
  width: 6px;
  height: 6px;
}

.lee-slide-runway.m .lee-slide-bar {
  height: 6px;border-radius: 3px;
}

.lee-slide-runway.m .lee-slide-wrap {
  width: 20px;
  height: 20px;
}

.lee-slide-runway.m .lee-slide-wrap .lee-slide-tooltip {
  padding: 4px 8px;
}

.lee-slide-runway.m .lee-slide-wrap .lee-slide-button {
  width: 20px;
  height: 20px;
}

.lee-slide-runway.l {
  height: 10px;
  border-radius: 5px;
}

.lee-slide-runway.l .lee-slide-stop {
  width: 10px;
  height: 10px;
}

.lee-slide-runway.l .lee-slide-bar {
  height: 10px;border-radius: 5px;
}

.lee-slide-runway.l .lee-slide-wrap {
  width: 26px;
  height: 26px;
}

.lee-slide-runway.l .lee-slide-wrap .lee-slide-tooltip {
  padding: 6px 10px;
}

.lee-slide-runway.l .lee-slide-wrap .lee-slide-button {
  width: 26px;
  height: 26px;
}


</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeSlide.vue